module.exports = __webpack_public_path__ + "img/v-cutter.913db1cc.png";